import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import { POPUP_CONNECTION_STATE, popupSteps } from "../../../../../store/common/constants";
import { submitCallbackRequest } from "../../../../../store/callbackRequest/actions/submitCallbackRequest";
import { requestApiTexts } from "../actions/requestApiTexts";
import { formatCommonKeys, getConnectionStatus, getStepStatus } from "../../utils/utils";
import { fetchCheckConnection } from "../actions/handleCheckConnection";
import { requestInitData } from "../actions/requestInitData";
var initialState = {
  currentStep: popupSteps.addressRequestForm,
  statusConnection: POPUP_CONNECTION_STATE.isNone,
  isLoading: false,
  tariffData: undefined,
  popupData: undefined,
  tariffType: undefined,
  showOnlyRouterInAlternativeUpTariff: false,
  personalVerificationCheckboxEnable: true,
  isRedirectToFTTBDetailsPage: false,
  region: {
    id: 0,
    label: ''
  },
  isCheckboxError: false,
  fttbCheckAddressOneFieldEnabled: undefined,
  fttbPersonalVerificationCheckboxEnable: undefined,
  uniConstructorRedirectFlag: false
};
export var checkAddressSlice = createSlice({
  name: 'checkAddressPopup',
  initialState: initialState,
  reducers: {
    setLoading: function setLoading(state, _ref) {
      var payload = _ref.payload;
      state.isLoading = payload;
    },
    setNextStep: function setNextStep(state, _ref2) {
      var payload = _ref2.payload;
      state.currentStep = payload;
    },
    backToPreviousStep: function backToPreviousStep(state) {
      state.currentStep -= 1;
    },
    setOrderTariffType: function setOrderTariffType(state, _ref3) {
      var payload = _ref3.payload;
      state.tariffType = payload;
    },
    setStatusConnection: function setStatusConnection(state, _ref4) {
      var payload = _ref4.payload;
      state.statusConnection = payload;
    },
    setAlternativeTariff: function setAlternativeTariff(state, _ref5) {
      var payload = _ref5.payload;
      state.tariffData = payload;
    },
    resetStepsData: function resetStepsData(state) {
      state.tariffData = undefined;
      state.tariffType = undefined;
      state.currentStep = popupSteps.addressRequestForm;
      state.statusConnection = POPUP_CONNECTION_STATE.isNone;
      state.isCheckboxError = false;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchCheckConnection.fulfilled, function (state, _ref6) {
      var _state$tariffType;
      var payload = _ref6.payload;
      var View = payload.View,
        IsSucceeded = payload.IsSucceeded,
        tariff = payload.tariff;
      if (!isEmpty(tariff)) {
        state.tariffData = tariff;
      }
      var isHighSpeedTariff = (_state$tariffType = state.tariffType) === null || _state$tariffType === void 0 ? void 0 : _state$tariffType.isHighSpeedTariff;
      state.statusConnection = getConnectionStatus(View);
      state.currentStep = getStepStatus({
        IsSucceeded: IsSucceeded,
        View: View,
        isHighSpeedTariff: isHighSpeedTariff
      });
      state.isLoading = false;
    }).addCase(submitCallbackRequest.fulfilled, function (state, _ref7) {
      var payload = _ref7.payload;
      if (payload.isSucceeded && !payload.isCaptchaError) {
        state.currentStep = popupSteps.shortSuccess;
        state.statusConnection = POPUP_CONNECTION_STATE.success;
      }
      state.isLoading = false;
    }).addCase(fetchCheckConnection.rejected, function (state) {
      state.isLoading = false;
      state.currentStep = popupSteps.addressNotAvailableModal;
    }).addCase(requestInitData.fulfilled, function (state, _ref8) {
      var payload = _ref8.payload;
      state.popupData = payload === null || payload === void 0 ? void 0 : payload.callbackRequestData;
      state.showOnlyRouterInAlternativeUpTariff = payload.showOnlyRouterInAlternativeUpTariff;
      state.isRedirectToFTTBDetailsPage = payload.isRedirectToFTTBDetailsPage;
      state.uniConstructorRedirectFlag = payload.isUniversalConstructorDetailedPageEnabled;
      state.region = payload.region;
    }).addCase(requestApiTexts.fulfilled, function (state, _ref9) {
      var payload = _ref9.payload;
      Object.entries(formatCommonKeys(payload.texts)).forEach(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
          key = _ref11[0],
          value = _ref11[1];
        // @ts-expect-error fix later
        state[key] = value;
      });
    }).addMatcher(isAnyOf(fetchCheckConnection.pending, submitCallbackRequest.pending), function (state) {
      state.isLoading = true;
    }).addMatcher(isAnyOf(submitCallbackRequest.rejected, requestInitData.rejected), function (state) {
      state.isLoading = false;
      state.currentStep = popupSteps.fail;
    });
  }
});
var _checkAddressSlice$ac = checkAddressSlice.actions,
  setLoading = _checkAddressSlice$ac.setLoading,
  backToPreviousStep = _checkAddressSlice$ac.backToPreviousStep,
  setStatusConnection = _checkAddressSlice$ac.setStatusConnection,
  setOrderTariffType = _checkAddressSlice$ac.setOrderTariffType,
  resetStepsData = _checkAddressSlice$ac.resetStepsData,
  setNextStep = _checkAddressSlice$ac.setNextStep;
export { setLoading, backToPreviousStep, setStatusConnection, setOrderTariffType, resetStepsData, setNextStep };
export var checkAddressOldReducer = checkAddressSlice.reducer;